import { passwordSchema } from '~/utils/validation';
import { z } from 'zod';

export const schema = z.object({
  new_password1: passwordSchema,
  new_password2: passwordSchema,
});

export type Schema = z.infer<typeof schema>;
